"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAX_LIMIT_FOR_ZERO_SELECTION = exports.DEFAULT_OPTION_GROUP = exports.PRODUCT_UNITS = exports.DEFAULT_PRODUCT_MODIFIER_GROUP_NAME = void 0;
const products_1 = require("../enums/products");
exports.DEFAULT_PRODUCT_MODIFIER_GROUP_NAME = 'MISCELLANEOUS';
exports.PRODUCT_UNITS = {
    [products_1.UnitType.Volume]: ['mL', 'L'],
    [products_1.UnitType.Weight]: ['Kg', 'g'],
};
exports.DEFAULT_OPTION_GROUP = 'DEFAULT';
exports.DEFAULT_MAX_LIMIT_FOR_ZERO_SELECTION = 999;
//# sourceMappingURL=products.js.map